module.exports = __webpack_public_path__ + "media/images/site/VESTIBULAR_CONSTRUA_O_SEU_RESULTADO-5a87d43a1a135f999a3cd4914bcee7e4.jpg";